module.exports = {"420921100":"花园镇","420921101":"丰山镇","420921102":"周巷镇","420921103":"小河镇","420921104":"王店镇","420921105":"卫店镇","420921106":"白沙镇","420921107":"邹岗镇","420921200":"小悟乡","420921201":"季店乡","420921202":"花西乡","420921203":"陡山乡","420921400":"开发区","420921450":"观音湖生态文化旅游渡假区","420921500":"双峰山旅游渡假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420921.json
// module id = 1880
// module chunks = 0